module.exports = __webpack_public_path__ + "img/cnu_detail.df66e9fe.jpg";